import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TaskApiService from '../../../api/TaskApiService';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import PastRecurrenceDetailsPanel from './Components/PastRecurrenceDetailsPanel';
import { useSnackbar } from '../../Common/SnackbarProvider';

export default function RecurrencePastCompletionsModal(props) {
    const { open, close, taskApiService, taskId } = props;
    const { t } = useTranslation();
    const snackbar = useSnackbar();

    const[recurrences, setRecurrences] = useState([]);

    const columns = [
        {
            field: 'due',
            headerName: t('pastCompletions.column.dueDate'),
            flex: 1,
            renderCell: (params) => params.row.due.substring(0, 10),
            valueGetter: (params) => params.row.due.substring(0, 10),
        },
        {
            field: 'completed',
            headerName: t('pastCompletions.column.completed'),
            flex: 1,
            renderCell: (params) => params.row.completed.substring(0, 10),
            valueGetter: (params) => params.row.completed.substring(0, 10),
        },
        {
            field: 'completedByUser.username',
            headerName: t('common.completedBy'),
            flex: 2,
            renderCell: (params) => {
                return params.row.completedByUser.username;
            }
        }
    ];

    async function loadRecurrences() {
        const recurrencesResponse = await taskApiService.getCompletedRecurrencesForTask(taskId);

        if(recurrencesResponse.success) {
            setRecurrences(recurrencesResponse.data);
        } else if (recurrencesResponse.message) {
            snackbar.error(t('pastCompletions.toast.loadError', { error: recurrencesResponse.message }));
        } else if(recurrencesResponse) {
            snackbar.error(t('pastCompletions.toast.loadError', { error: recurrencesResponse }));
        }
    }

    const getDetailPanelHeight = React.useCallback(() => 400, []);
    const getDetailPanelContent = React.useCallback(({row}) => <PastRecurrenceDetailsPanel row={row} />, []);

    useEffect(() => {
        if(open) {
            loadRecurrences();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return(
        <Dialog open={open}
                sx={{ '& .MuiDialog-paper': { width: '100%' } }}
                maxWidth={'md'}
                fullWidth
        >
            <DialogTitle>{t('pastCompletions.title')}</DialogTitle>
            <DialogContent>
                <Box sx={{height: '500px'}}>
                    <DataGridPro
                        columns={columns}
                        rows={recurrences}
                        getRowHeight={() => 'auto'}
                        getDetailPanelHeight={getDetailPanelHeight}
                        getDetailPanelContent={getDetailPanelContent}
                    />
                </Box>

            </DialogContent>
            <DialogActions>
                <Button onClick={close}>{t('common.close')}</Button>
            </DialogActions>
        </Dialog>
    );
}

RecurrencePastCompletionsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    taskApiService: PropTypes.objectOf(TaskApiService),
    taskId: PropTypes.string.isRequired,
};
